import './scss/main.scss';


export function Cube() {
  return (
    <div className='body'>
    <div className="cube">
        <div className="top"></div>
        <div>
            <span className='first'></span>
            <span className='second'></span>
            <span className='third'></span>
            <span className='fourth'></span>
        </div>
    </div>
    </div>
  );
}
